/**
 * This component is used to display a player's information in a game.
 */
import React from "react";
import AllStar from "./AllStarIndividual";

const AllStarLine = ({players, is_nm=false}) => {
    if (is_nm) {
        return (
            <div className="flex flex-wrap xs:flex-row w-full xs:mt-4 mt-2 pb-2 justify-center items-center">
                <AllStar
                    player={players[6]}
                    title={"Starter"}
                    nm={true}
                />
                <AllStar
                    player={players[7]}
                    title={"Backup"}
                    nm={true}
                />
            </div>
        )
    }

    return (
        <>
            <div className="flex flex-wrap xs:flex-row w-full xs:mt-4 mt-2 pb-2 justify-center align-middle">
                <AllStar
                    player={players[1]}
                    title={"Left Wing"}
                />
                <AllStar
                    player={players[4]}
                    title={"Left Defence"}
                    extraClasses={'max-md:hidden pt-20'}
                />
                <AllStar
                    player={players[2]}
                    title={"Centre"}
                />
                <AllStar
                    player={players[5]}
                    title={"Right Defence"}
                    extraClasses={'max-md:hidden pt-20'}
                />
                <AllStar
                    player={players[3]}
                    title={"Right Wing"}
                />
            </div>

            <div className="flex flex-wrap xs:flex-row w-full xs:mt-4 mt-2 pb-2 justify-center">
                <AllStar
                    player={players[4]}
                    title={"Left Defence"}
                    extraClasses={'md:hidden'}
                />
                <AllStar
                    player={players[5]}
                    title={"Right Defence"}
                    extraClasses={'md:hidden'}
                />
            </div>
        </>
    );
};
export default AllStarLine;
